export default __webpack_public_path__ + "c85a60204c705b99e9bfe59bba328f7e.svg";